import { render, staticRenderFns } from "./NewsRadioSelect.vue?vue&type=template&id=58c2182e"
import script from "./NewsRadioSelect.vue?vue&type=script&lang=js"
export * from "./NewsRadioSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports